import { Avatar, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { Dispatch, FunctionComponent, SetStateAction } from 'react';
import { gamePalette } from '../config/GameTheme';
import { Team } from '../types/GameplayTypes';
import { useScreenIsNarrow } from './Accessibility';

type Props = {
	team: Team;
	state: [string, Dispatch<SetStateAction<string>>];
};

export const TeamNameEntry: FunctionComponent<Props> = (props) => {
	const narrow = useScreenIsNarrow();

	const [name, setName] = props.state;
	const isA = props.team === Team.A;

	const MAX_LENGTH = 20;
	const charsRemaining = MAX_LENGTH - name.length;

	function handleChange(value: string) {
		if (value.length <= MAX_LENGTH) {
			setName(value);
		}
	}

	return <Stack direction='row' spacing={2} sx={{ alignItems: 'center' }}>
		<TextField
			label={isA ? 'Blue team name' : 'Red team name'}
			value={name}
			onChange={(e) => handleChange(e.target.value)}
			variant="outlined"
			error={charsRemaining < 0}
			slotProps={{
				input: {
					endAdornment: (
						<InputAdornment position="end">
							<Typography variant="caption" color={charsRemaining <= 0 ? 'error' : 'text.secondary'}>
								{charsRemaining}/{MAX_LENGTH}
							</Typography>
						</InputAdornment>
					),
				},
			}}
			sx={[narrow || { width: `${MAX_LENGTH + 4}rem` }]}
		/>
		<Avatar sx={{ bgcolor: gamePalette[isA ? 'teamA' : 'teamB'] }}> </Avatar>
	</Stack>;
};